import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { IsInRolePipe } from './pipes/is-in-role.pipe';
import { StringContainsPipe } from './pipes/string-contains.pipe';
import { ConfirmDialogComponent } from './components/_modals/modal-confirm-dialog/confirm-dialog.component';
import { ClickOutsideDirective } from '../core/directives/click-outside.directive';
import { PlaylistSortPipe } from '../core/pipes/playlist-sort.pipe';
import { PlaylistFilterPipe } from '../core/pipes/playlist-filter.pipe';
import { SafePipe } from '../core/pipes/safe.pipe';
import { LauncherSortPipe } from '../core/pipes/launcher-sort.pipe';
import { ModalProcessingStatusComponent } from './components/_modals/modal-processing-status/modal-processing-status.component';
import { VideoPreviewComponent } from './components/_modals/video-preview/video-preview.component';

@NgModule({
  declarations: [
    IsInRolePipe,
    StringContainsPipe,
    ConfirmDialogComponent,
    ClickOutsideDirective,
    PlaylistSortPipe,
    PlaylistFilterPipe,
    SafePipe,
    LauncherSortPipe
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ModalProcessingStatusComponent,
    VideoPreviewComponent
  ],
  exports: [
    IsInRolePipe,
    StringContainsPipe,
    ClickOutsideDirective,
    PlaylistSortPipe,
    PlaylistFilterPipe,
    SafePipe,
    LauncherSortPipe
  ]
})
export class SharedModule { }
